<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
		  <el-menu-item index="list">编辑框架协议</el-menu-item>
		  <el-menu-item index="list2">关联商务合同列表</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
		  <editAccord  v-if="activeIndex == 'list'"></editAccord>
		  <relationList v-else-if="activeIndex == 'list2'"></relationList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import relationList from "./relationList.vue";//关联商务合同列表
import editAccord from "./addAccord/addForm.vue";
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
    };
  },
  components: {
	editAccord,relationList
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath) {
		console.log(key, keyPath)
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
  },
};
</script>